import 'dayjs/locale/ja'

import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.locale('ja')
dayjs.extend(utc)
dayjs.extend(timezone)

export { dayjs }
